import angular from 'angular';
import OrchestrationErrorService from './orchestrationError.service';

let orchestrationErrorModule = angular.module('orchestrationError', []).service('orchestrationErrorService', OrchestrationErrorService);

export default orchestrationErrorModule;



// WEBPACK FOOTER //
// ./app/common/orchestrationError/orchestrationError.js